
import { Component, Emit, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import FormInput from "../form/FormInput.vue";
import FormSelect from "../form/FormSelect.vue";
import FormCheckbox from "../form/FormCheckbox.vue";
import FormTextarea from "../form/FormTextarea.vue";
import FormTel from "../form/FormTel.vue";
import ActionButton from "../../../../common/src/components/ActionButton.vue";
import { FormErrors } from "../../../../common/src/form/types";
import { QuiltyResourceBody } from "@gsx/common/src/types/http/admin/quiltyResource";
import { Nullable } from "@gsx/common";

import QuiltyResourceFilePane from "./QuiltyResourceFilePane.vue";
import QuiltyResourcePicturePane from "./QuiltyResourcePicturePane.vue";
import { Api } from "../../../../common/src/api/Api";
import { Container } from "inversify";
import QuiltyResourceGeneralPane from "./QuitlyResourceGeneralPane.vue";

@Component({
    components: {
        FormTel,
        FormTextarea,
        FormCheckbox,
        FormSelect,
        ActionButton,
        FormInput,
    },
})
export default class QuiltyResourceForm extends Vue {
    @Inject("container") readonly container!: Container;
    @Prop({ default: false }) loading!: boolean;
    @Prop() values!: Nullable<QuiltyResourceBody>;
    @Prop() errors!: FormErrors<QuiltyResourceBody>;
    @Prop({ default: "Update QuiltyResource" }) submitText!: string;
    @Prop() admin!: boolean;
    @Prop() value?: { resource: File; picture: File };
    media?: { resource?: File; picture?: File } = this.value;
    readonly api: Api = this.container.get(Api);

    @Watch("media")
    propagateMedia() {
        if (this.media && (this.media.resource || this.media.picture)) {
            this.input();
        }
    }

    @Emit()
    input() {
        return this.media;
    }

    readonly tabs = [
        {
            title: "General <br />Information",
            component: QuiltyResourceGeneralPane,
        },
        {
            title: "File <br />Upload",
            component: QuiltyResourceFilePane,
        },
        {
            title: "Picture <br />Upload",
            component: QuiltyResourcePicturePane,
        },
    ];

    activeTab: number = 0;

    get enrichedTabs(): any[] {
        return this.tabs.map((tab, index) => ({
            ...tab,
            active: index === this.activeTab,
        }));
    }

    activateTab(index: number) {
        this.activeTab = index;
    }

    @Emit()
    submit() {
        //
    }
}
